<template>
    <a :id="id" :href="link" ref="button" class="">
        <slot></slot>
    </a>
</template>
<script>
import mixins from '@utils/mixins';
import { route } from '@utils/network';

export default {
    name: 'LinkButton',
    computed: {
        id() {
            return `link-button-${ this._uid }`;
        },

        link() {
            return route(this.route, this.params)
        }
    },
    mixins: [ mixins ],
    props: {
        route: String,
        params: String|Object|Number|Array,
        tooltip: String
    },

    mounted() {
        if (this.tooltip) {
            this.initializeTooltip(`#${ this.id }`, this.tooltip)
        }
    }
}
</script>